import { executeRequest, Request, Response } from '@jfs/network'
import { getAPIURL, getPaymentHeader } from '../config'

const returnStrgWithFullStop = (vaule: string) => {
  return vaule ? `• ${vaule.replace(/\n/g, '\n• ')}` : ''
}
const responseParser = (response: Response) => {
  console.log('******* response: ', response)

  const {
    data: { offers = [] },
  } = response

  const retData = offers.map((item: any) => {
    const offer = {
      ...item,
      id: item?.code,
      name: item?.name,
      description: item?.description,
      status: item?.status,
      offerType: item?.offerType,
      cashBackAmount: {
        amount: item?.cashBackAmount?.amount,
      },
      paymentModeSubType: item?.method?.subType,
      paymentModeType: item?.method?.type,
      instantDiscountAmount: {
        amount: item?.instantDiscountAmount?.amount,
      },
      termsConditions: returnStrgWithFullStop(item?.termsConditions ?? ''),
      offerPeriod: {
        startDate: item?.startDate,
        endDate: item?.endDate,
        timeDuration: '',
      },
      bankIds: item?.bankIds,
    }
    return offer
  })
  console.log('********  retData: ', retData)
  return retData
}
/**
 * New PG
 * @param merchantID
 */
export const getOffers = (input: any) => {
  const request: Request<{}> = {
    apiPath: `${getAPIURL('getOffers')}`,
    method: 'POST',
    headers: getPaymentHeader(),
    body: { ...input },
  }
  return executeRequest(request)
    .then((data) => {
      if (data?.status === 'SUCCESS') {
        return responseParser(data)
      } else {
        throw data
      }
    })
    .catch((err) => {
      console.log('err: ', err)
      const {
        data: { error },
      } = err
      throw error
    })
}
